import styled from "styled-components";
import { Grid } from "@material-ui/core";

export const StyledGridContainer = styled(Grid)`
    & .MuiGrid-root {
        margin-bottom: 1em;
    }
`;
